import React, { Ref } from 'react';

import { CustomContentProps, closeSnackbar } from 'notistack';
import { LbAlert } from '../../../components/ui-components';

const LbSnackbarAlert = ({
  variant,
  message,
  id,
  ref,
}: CustomContentProps & { ref: Ref<HTMLDivElement> }) => {
  return (
    <LbAlert ref={ref} severity={variant} onClose={() => closeSnackbar(id)}>
      {message}
    </LbAlert>
  );
};

export { LbSnackbarAlert };
